import { c as _c } from "react/compiler-runtime";
import { Input, Skeleton, Spinner } from '@common/components';
import { useToast } from '@common/hooks';
import { SvgChevrondown, SvgTarget2 } from '@common/icon';
import { useId, useState } from 'react';
import type { SEARCH_PARAMS_TYPE } from '@/constants';
import type { LocationData } from '@/hooks/useLocation';
import { useLocation } from '@/hooks/useLocation';
import type { SelectedRegion } from './RegionPickerDialog';
import { RegionPickerDialog } from './RegionPickerDialog';
import { useRegionMetaData } from './useRegionMetaData';
interface RegionSelectProps {
  value?: SEARCH_PARAMS_TYPE.SELECTED_REGION;
  onChange?: (value: SelectedRegion) => void;
  onClickGps?: (value: LocationData) => void;
  id?: string;
  className?: string;
  labelClassName?: string;
  label?: string;
  placeholder?: string;
  isLoading?: boolean;
  enableMainRegionCodeList?: string[];
  enableLocation?: boolean;
  enableWholeRegion?: boolean;
  enableWholeCountry?: boolean;
}
export const RegionSelect = t0 => {
  const $ = _c(49);
  const {
    value,
    onChange,
    onClickGps,
    id,
    className,
    labelClassName,
    label: t1,
    isLoading: t2,
    enableMainRegionCodeList,
    enableLocation: t3,
    enableWholeRegion: t4,
    enableWholeCountry: t5,
    placeholder: t6
  } = t0;
  const label = t1 === undefined ? "\uC9C0\uC5ED" : t1;
  const isLoading = t2 === undefined ? false : t2;
  const enableLocation = t3 === undefined ? true : t3;
  const enableWholeRegion = t4 === undefined ? false : t4;
  const enableWholeCountry = t5 === undefined ? false : t5;
  const placeholder = t6 === undefined ? "\uC9C0\uC5ED\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694." : t6;
  const regionMetaDataQuery = useRegionMetaData();
  const regionMetaData = regionMetaDataQuery.data;
  const {
    refetch: getLocation,
    isLoading: isLocationLoading
  } = useLocation();
  const {
    toast
  } = useToast();
  const [opened, setOpened] = useState(false);
  const inputId = useId();
  let t7;
  if ($[0] !== regionMetaData?.mainRegionByCode || $[1] !== value) {
    t7 = value?.mainRegionCode ? regionMetaData?.mainRegionByCode.get(value.mainRegionCode) : undefined;
    $[0] = regionMetaData?.mainRegionByCode;
    $[1] = value;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const mainRegion = t7;
  let t8;
  if ($[3] !== regionMetaData?.subRegionByCode || $[4] !== value) {
    t8 = value?.subRegionCode ? regionMetaData?.subRegionByCode.get(value.subRegionCode) : undefined;
    $[3] = regionMetaData?.subRegionByCode;
    $[4] = value;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const subRegion = t8;
  const selectedRegionText = !mainRegion ? enableWholeCountry ? "\uC804\uAD6D" : "" : subRegion ? `${mainRegion.value} > ${subRegion.value}` : enableWholeRegion && value?.mainRegionCode ? `${mainRegion.value} 전체` : "";
  const isPending = isLoading || isLocationLoading || regionMetaDataQuery.isLoading;
  let t9;
  if ($[6] !== id || $[7] !== inputId || $[8] !== label || $[9] !== labelClassName) {
    t9 = <label className={labelClassName} htmlFor={inputId} id={id}>{label}</label>;
    $[6] = id;
    $[7] = inputId;
    $[8] = label;
    $[9] = labelClassName;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== enableLocation || $[12] !== getLocation || $[13] !== isLocationLoading || $[14] !== isPending || $[15] !== onChange || $[16] !== onClickGps || $[17] !== regionMetaData?.mainRegionByCode || $[18] !== regionMetaData?.subRegionByCode || $[19] !== toast) {
    t10 = enableLocation ? isPending ? <Skeleton className="w-55" typo="body4" /> : <button className="flex items-center gap-5 font-400 text-Gray-900 typo-body4" type="button" onClick={async () => {
      const {
        data: location
      } = await getLocation();
      if (!location) {
        toast({
          message: "\uC704\uCE58 \uC815\uBCF4\uB97C \uAC00\uC838\uC624\uB294\uB370 \uC2E4\uD328\uD588\uC5B4\uC694."
        });
        return;
      }
      const mainRegion_0 = location.codeRegion ? regionMetaData?.mainRegionByCode.get(location.codeRegion) : undefined;
      const subRegion_0 = location.codeSubRegion ? regionMetaData?.subRegionByCode.get(location.codeSubRegion) : undefined;
      if (!mainRegion_0 || !subRegion_0) {
        toast({
          message: "\uD604\uC7AC \uC704\uCE58\uC758 \uC9C0\uC5ED \uC815\uBCF4\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC5B4\uC694."
        });
        return;
      }
      onChange?.({
        mainRegion: mainRegion_0,
        subRegion: subRegion_0
      });
      onClickGps?.(location);
      toast({
        message: "\uD604\uC7AC \uC704\uCE58\uAC00 \uC124\uC815\uB418\uC5C8\uC5B4\uC694."
      });
    }}>{isLocationLoading ? <Spinner size={14} /> : <SvgTarget2 className="size-14" name={"\uC704\uCE58 \uC815\uBCF4 \uC5C5\uB370\uC774\uD2B8"} />}현위치</button> : null;
    $[11] = enableLocation;
    $[12] = getLocation;
    $[13] = isLocationLoading;
    $[14] = isPending;
    $[15] = onChange;
    $[16] = onClickGps;
    $[17] = regionMetaData?.mainRegionByCode;
    $[18] = regionMetaData?.subRegionByCode;
    $[19] = toast;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div className="mb-10 flex w-full items-center justify-between gap-4 text-Gray-800 typo-body4">{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== isPending) {
    t12 = isPending ? <Spinner size={20} /> : <SvgChevrondown className="size-20 text-Gray-700" name={"\uC5F4\uAE30"} />;
    $[24] = isPending;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== isPending) {
    t13 = () => {
      if (isPending) {
        return;
      }
      setOpened(true);
    };
    $[26] = isPending;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== inputId || $[29] !== placeholder || $[30] !== selectedRegionText || $[31] !== t12 || $[32] !== t13) {
    t14 = <Input readOnly={true} className="w-full" id={inputId} placeholder={placeholder} rightContent={t12} type="button" value={selectedRegionText} onClick={t13} />;
    $[28] = inputId;
    $[29] = placeholder;
    $[30] = selectedRegionText;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setOpened(false);
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== onChange) {
    t16 = region => onChange?.(region);
    $[35] = onChange;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== enableMainRegionCodeList || $[38] !== enableWholeCountry || $[39] !== enableWholeRegion || $[40] !== opened || $[41] !== t16 || $[42] !== value) {
    t17 = <RegionPickerDialog opened={opened} onClose={t15} onConfirm={t16} value={value} title={"\uAD00\uC2EC \uC9C0\uC5ED\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694"} enableMainRegionCodeList={enableMainRegionCodeList} enableWholeRegion={enableWholeRegion} enableWholeCountry={enableWholeCountry} />;
    $[37] = enableMainRegionCodeList;
    $[38] = enableWholeCountry;
    $[39] = enableWholeRegion;
    $[40] = opened;
    $[41] = t16;
    $[42] = value;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== className || $[45] !== t11 || $[46] !== t14 || $[47] !== t17) {
    t18 = <div className={className}>{t11}{t14}{t17}</div>;
    $[44] = className;
    $[45] = t11;
    $[46] = t14;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  return t18;
};